import React from 'react';
import {Radio} from 'antd';
import {t} from '../../../services/i18n';

const YesNoQuestion = ({value, onChange, disabled}) => (
    <Radio.Group value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)}>
        <Radio value="true">{t('yes')}</Radio>
        <Radio value="false">{t('no')}</Radio>
    </Radio.Group>
);

export default YesNoQuestion;
